// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/img/intro-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styles */
body,
html {
  font-family: "Open Sans", sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  color: #000000;
  font-weight: 400;
  width: 100% !important;
  height: 100% !important;
  background-color: #dcca98;
}
h2,
h3,

h4 {
  font-family: "Raleway", sans-serif;
}

h2 {
  text-transform: uppercase;
  margin: 0 0 20px;
  font-weight: 800;
  font-size: 36px;
  color: #114040;
}

h3 {
  font-size: 30px;
  font-weight: 600;
  color: #114040;
}

h4 {
  font-size: 18px;
  font-weight: 600;
  color: #114040;
}

.h4-text {
  font-size: 18px;
  color: #dcca98;
  font-weight: 600;
}

h5 {
  text-transform: uppercase;
  font-weight: 700;
  line-height: 20px;
}

h6 {
  justify-content: center;
  text-transform: uppercase;
  margin: 0 0 20px;
  font-size: large;
  font-weight: bold;
  color: #dcca98;
}

p {
  font-size: 16px;
}

p.intro {
  margin: 12px 0 0;
  line-height: 24px;
}

a {
  color: #608dfd;
  font-weight: 400;
}

a:hover,
a:focus {
  text-decoration: none;
  color: #608dfd;
}

ul,
ol {
  list-style: none;
  padding: 0;
}

hr {
  height: 2px;
  width: 70px;
  text-align: center;
  position: relative;
  background: #000000;
  margin-bottom: 20px;
  border: 0;
}

/* Navigation */
#menu {
  padding: 0;
  transition: all 0.8s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  width: 100%;
  margin: 0;
}

#menu.navbar-default {
  background-color: #dcca98;
  border-color: rgba(231, 231, 231, 0);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: visible;
  position: fixed;
  top: 0;
  width: 100%;
  height: 70px;
  margin: 0;
  border: none;
  padding: 0;
}

#menu a.navbar-brand {
  font-family: "Raleway", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #000000;
  text-transform: uppercase;
  padding: 0 15px;
  height: 70px;
  display: flex;
  align-items: center;
  overflow: visible;
}

#menu.navbar-default .navbar-nav {
  display: flex;
  height: 70px;
  align-items: center;
  margin: 0;
}

#menu.navbar-default .navbar-nav > li {
  list-style: none;
  margin: 0 15px;
  display: flex;
  align-items: center;
  height: 100%;
}

#menu.navbar-default .navbar-nav > li > a {
  font-family: "Lato", sans-serif;
  text-transform: uppercase;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  padding: 12px 2px;
  border-radius: 0;
  position: relative;
}

#menu.navbar-default .navbar-nav > li > a:after {
  display: block;
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 0;
  height: 2px;
  background: linear-gradient(to right, #114040 0%, #144c4c 100%);
  content: "";
  transition: width 0.2s;
}

#menu.navbar-default .navbar-nav > li > a:hover:after {
  width: 100%;
}

.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:hover,
.navbar-default .navbar-nav > .active > a:focus {
  background-color: transparent;
}

.navbar-default .navbar-nav > .active > a:after,
.navbar-default .navbar-nav > .active > a:hover:after,
.navbar-default .navbar-nav > .active > a:focus:after {
  display: block !important;
  position: absolute !important;
  left: 0 !important;
  bottom: -1px !important;
  width: 100% !important;
  height: 2px !important;
  background: linear-gradient(to right, #114040 0%, #144c4c 100%) !important;
  content: "" !important;
  transition: width 0.2s !important;
}

@media (max-width: 767px) {
  .navbar-nav {
    display: block;
    text-align: center;
  }

  .navbar-nav li {
    display: block;
    margin: 0;
  }

  .navbar-nav li a {
    padding: 15px;
  }
}

.brand-title,
.brand-subtitle {
  display: block;
  line-height: 1;
}

.brand-subtitle {
  font-size: 13px;
  color: #144c4c;
}

.brand-container {
  display: flex;
  align-items: center;
  height: 70px;
  overflow: visible;
}

.brand-logo {
  width: 45px;
  height: 45px;
  margin-right: 15px;
  object-fit: contain;
}

/* Brand text container */
.brand-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 45px;
}

.brand-title {
  font-size: 18px;
  line-height: 1.4;
  font-weight: bold;
  margin: 0;
}

.brand-subtitle {
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
}

@media (min-width: 768px) {
  .brand-title,
  .brand-subtitle {
    display: inline;
  }
}


.section-title {
  margin-bottom: 70px;
}

.section-title h2 {
  position: relative;
  margin-top: 10px;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.section-title h2::after {
  position: absolute;
  content: "";
  background: linear-gradient(to right, #114040 0%, #144c4c 100%);
  height: 4px;
  width: 60px;
  bottom: 0;
  margin-left: -30px;
  left: 50%;
}

.section-title p {
  font-size: 18px;
}

.btn-custom {
  font-family: "Raleway", sans-serif;
  text-transform: uppercase;
  color: #dcca98;
  background-color: #5ca9fb;
  background-image: linear-gradient(to right, #114040 0%, #144c4c 100%);
  padding: 14px 34px;
  letter-spacing: 1px;
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  border-radius: 25px;
  transition: all 0.5s linear;
  border: 0;
}

.btn-custom:hover,
.btn-custom:focus,
.btn-custom.focus,
.btn-custom:active,
.btn-custom.active {
  color: #fff;
  background-image: none;
  background-color: #6372ff;
}

.btn:active,
.btn.active {
  background-image: none;
  outline: 0;
  box-shadow: none;
}

a:focus,
.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
  outline: none;
  outline-offset: none;
}

/* Header Section */
.intro {
  width: 100%;
  padding: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat fixed;
  background-color: #144040;
  background-size: cover;
  -o-background-size: cover;
  position: relative;
}

.intro .overlay {
  background: rgba(0, 0, 0, 0.4);
  padding: 100px 0;
}

.header-row {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 550px;
}

.intro-text {
  position: relative;
  z-index: 2;
}

.intro h1 {
  font-family: "Times", cursive;
  color: #ffbb00;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
  font-size: 40px;
  font-weight: 700;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 10px;
  text-align: center;
}

.intro h1 span {
  font-weight: 800;
  color: #5ca9fb;
}

.intro p {
  text-align: center;
  font-family: "Times", cursive;
  color: #ffbb10;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
  font-size: 30px;
  font-weight: 500;
  line-height: 30px;
  margin: 0 auto;
  margin-bottom: 60px;
}

header .intro-text {
  padding-top: 50px;
  padding-bottom: 50px;
  min-height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive adjustments for smaller screens */
@media screen and (max-width: 767px) {
  .intro {
    height: auto;
  }

  .intro .overlay {
    padding: 60px 0;
  }

  .header-row {
    min-height: auto;
  }

  .intro h1 {
    font-size: 24px;
    text-align: center;
  }

  .intro p {
    font-size: 16px;
    margin-bottom: 30px;
    text-align: center;
  }

  .intro-text {
    padding-top: 30px;
    padding-bottom: 30px;
    min-height: auto;
  }
}

/* meetyourassistants Section */
#meetyourassistants {
  padding: 100px 0;
  background: #114040;
}

#meetyourassistants h2 {
  color: #dcca98;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

#meetyourassistants h3 {
  color: #dcca98;
}

#meetyourassistants p {
  color: #dcca98;
}

#meetyourassistants i.fa {
  font-size: 38px;
  margin-bottom: 20px;
  transition: all 0.5s;
  color: #dcca98;
  width: 100px;
  height: 100px;
  padding: 30px 0;
  border-radius: 50%;
  background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.05);
}

#meetyourassistants .section-title h2::after {
  position: absolute;
  content: "";
  background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);
  height: 4px;
  width: 60px;
  bottom: 0;
  margin-left: -30px;
  left: 50%;
}

/* About Section */
#about {
  padding-top: 100px;
  background: #dcca98;
  padding-bottom: -100px;
}

#about h3 {
  font-size: 22px;
  margin: 0 0 20px;
}

#about h2 {
  position: relative;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

#about .section-title h2::after {
  position: absolute;
  content: "";
  background: linear-gradient(to right, #144c4c 0%, #144040 100%);
  height: 4px;
  width: 60px;
  bottom: 0;
  margin-left: -30px;
  left: 50%;
}

#about .about-text li {
  margin-bottom: 6px;
  margin-left: 6px;
  list-style: none;
  padding: 0;
  font-size: 16px;
}

#about .about-text li:before {
  content: "\\f00c";
  font-family: "FontAwesome";
  color: #114040;
  font-size: 16px;
  font-weight: 300;
  padding-right: 8px;
}

#about img {
  width: 520px;
  margin-top: 30px;
  background: #dcca98;
  border-right: 0;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.06);
}

#about p {
  line-height: 24px;
  margin: 30px 0;
}

/* features Section */
#features {
  padding: 100px 0;
  background: linear-gradient(to right, #114040 0%, #144c4c 100%);
  color: #dcca98;
}

#features .features-desc {
  margin: 10px 10px 20px;
}

#features h2 {
  color: #dcca98;
}

#features .section-title h2::after {
  position: absolute;
  content: "";
  background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);
  height: 4px;
  width: 60px;
  bottom: 0;
  margin-left: -30px;
  left: 50%;
}

#features i.fa {
  font-size: 42px;
  width: 120px;
  height: 120px;
  padding: 40px 0;
  background: linear-gradient(to right, #114040 0%, #144c4c 100%);
  border-radius: 50%;
  color: #dcca98;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.05);
}

#features h3 {
  font-weight: 500;
  padding: 5px 0;
  color: #dcca98;
}

#features p {
  color: #dcca98;
}

#features .features-desc {
  margin-bottom: 40px;
}

/* Assistants Section */
#assistants {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #dcca98;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
}

/* For devices with max width of 500px and specific viewport heights */
@media (max-width: 500px) and (max-height: 700px) {
  #assistants {
    margin-bottom: 120px;
    min-height: 150vh;
  }
}

@media (max-width: 500px) and (max-height: 800px) {
  #assistants {
    padding-bottom: 180px;
    min-height: 100vh;
  }
}

@media (max-width: 500px) and (max-height: 900px) {
  #assistants {
    padding-bottom: 180px;
    min-height: 100vh;
  }
}

@media (max-width: 500px) and (max-height: 1000px) {
  #assistants {
    margin-bottom: 120px;
    min-height: 150vh;
  }
}

/* Ensure the container takes up the appropriate width */
.container {
  max-width: 1200px;
  margin: 0 auto;
  height: auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* Assistants Item */
.assistants-item {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

/* Tab content to arrange the assistants */
.tab-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  flex-grow: 1;
}

.assistants-item img {
  width: 100%;
  height: auto;
}

.assistants-item .hover-bg {
  overflow: hidden;
  position: relative;
  margin: 0;
}

.hover-bg .hover-text {
  position: absolute;
  text-align: center;
  margin: 0 auto;
  color: #dcca98;
  background: linear-gradient(to right, rgba(99, 114, 255, 0.8) 0%, rgba(92, 169, 251, 0.8) 100%);
  padding: 30% 0 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: all 0.5s;
}

.hover-bg .hover-text > h4 {
  opacity: 0;
  color: #000000;
  transform: translateY(100%);
  transition: all 0.3s;
  font-size: 18px;
  letter-spacing: 1px;
  font-weight: 500;
  text-transform: uppercase;
}

.hover-bg:hover .hover-text > h4 {
  opacity: 1;
  -webkit-backface-visibility: hidden;
  transform: translateY(0);
}

.hover-bg:hover .hover-text {
  opacity: 1;
}

/* Team Section */
#team {
  padding: 100px 0;
  background: #dcca98;
}

#team h4 {
  margin: 5px 0;
}

#team .team-img {
  width: 240px;
}

#team .thumbnail {
  background: transparent;
  border: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  height: auto;
  margin-bottom: 15px;
}

#team .thumbnail .caption {
  padding: 10px 0 0;
  color: #000000;
  text-align: center;
}


/* Footer Section */
#footer {
  background: #dcca98;
  padding: 30px 0;
}

#footer p {
  color: #114040;
  font-size: 16px;
}

#footer a {
  color: #114040;
}

#footer a:hover {
  border-bottom: 2px solid #114040;
}

/* Navigation.css */
.navbar-header {
  display: flex;
  align-items: center;
  height: 70px;
  overflow: visible;
  padding: 0;
}

.brand-container {
  display: flex;
  align-items: center;
  height: 70px;
  overflow: visible;
}

.brand-logo {
  width: 45px;
  height: 45px;
  margin-right: 15px;
  object-fit: contain;
}

/* Brand text container */
.brand-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 45px;
}

.brand-title {
  font-size: 18px;
  line-height: 1.4;
  font-weight: bold;
  margin: 0;
}

.brand-subtitle {
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
}

.assistants-section .assistant-title h4 {
  margin: 0 auto;
  text-align: center;
  padding-bottom: 10px;
  color: #dcca98;
}

.assistants-section .assistant-title-button {
  background-color: #144c4c;
  border: none;
  font-size: large;
  font-weight: bold;
  color: #dcca98;
  padding: 10px 20px;
  text-align: center;
  width: 100%;
  display: block;
  cursor: pointer;
  transition: transform 0.3s ease, background-color 0.3s ease;
  border-radius: 5px;
}

.assistants-section .assistant-title-button:hover {
  background-color: #114040;
  transform: scale(1.05);
}

.assistants-section .assistant-container {
  margin-top: 10px;
  cursor: pointer;
  overflow: hidden;
}

.assistants-section .hover-bg {
  position: relative;
  transition: transform 0.3s ease;
}

.assistants-section .hover-bg:hover {
  transform: scale(1.05);
}

.assistants-section .hover-bg img {
  width: 100%;
  display: block;
  transition: transform 0.3s ease;
}

.assistant-container img {
  padding: 10px;
  width: 100%;
  max-width: 300px;
  height: auto;
  display: block;
  margin: 0 auto;
  object-fit: cover;
}

.assistants-section .hover-text {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  text-align: center;
  color: white;
  font-size: 20px;
  opacity: 0;
  transition: opacity 0.3s ease;
  background: rgba(49, 159, 218, 0.7);
  padding: 10px 0;
}

.assistants-section .hover-bg:hover .hover-text {
  opacity: 1;
}

@media (max-width: 768px) {
  #about img {
    margin: 50px 0;
  }
}

/* Modal.css */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  padding: 2em;
  background: #dcca98;
  border-radius: 5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 50%;
  margin: auto;
  text-align: center;
}

.modal-message {
  text-align: center;
  margin-bottom: 1em;
  font-size: 1.5rem;
  font-weight: bold;
  color: #144c4c;
}

.modal-submessage-container {
  max-height: 100px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #DCF8C6;
  width: calc(100% - 20px);
  max-height: 7em;
  margin: -10px 10px 0px 10px;
  font-size: small;
}

.modal-textarea {
  width: calc(100% - 20px);
  padding: 10px;
  margin: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none;
  height: 6em;
}

@media (min-width: 600px) {
  .modal-content {
    width: 70%;
  }
}

@media (max-width: 600px) {
  .modal-content {
    width: 90%;
    padding: 1em;
  }

  .modal-message {
    font-size: 1rem;
  }

  .modal-submessage {
    font-size: 0.8rem;
  }

  .modal-button.login {
    font-size: 1rem;
  }

  .modal-button.cancel {
    font-size: 1rem;
  }
}

/* Modal.css */
.modal-buttons-container {
  display: flex;
  gap: 10px;
  justify-content: center;
  width: 100%;
}

.modal-button {
  padding: 10px 20px;
  font-size: 1.5rem;
  color: #fff;
  background-color: #114040;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
}

.modal-button.login {
  background-color: #114040;
}

.modal-button.cancel {
  background-color: #357d7c;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background: #dcca98;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  z-index: 10000;
  color: #144040;
}

.popup-content h2 {
  margin-bottom: 20px;
  color: #144040;
}

.popup-content p {
  margin-bottom: 20px;
  color: #144040;
}

.popup-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.popup-content button {
  padding: 10px 20px;
  background: #144040;
  color: #dcca98;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.popup-content button:hover {
  background: #0F3030;
}

.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #114040;
}

.home-button {
  position: absolute;
  top: 20px;
  left: 20px;
  padding: 10px 20px;
  background-color: #dcca98;
  color: #144c4c;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.home-button:hover {
  background-color: #bbaa88;
}

.register-form {
  padding: 2em;
  background: #dcca98;
  border-radius: 5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 50%;
  margin: auto;
}

.register-form h2 {
  text-align: center;
  margin-bottom: 1em;
  color: #144c4c;
}

.register-form .event-description {
  font-size: 1em;
  color: #144c4c;
  margin-bottom: 1.5em;
  line-height: 1.5;
}

@media (max-width: 1024px) {
  .register-form {
    width: 70%;
  }
}

@media (max-width: 600px) {
  .register-form {
    width: 90%;
    padding: 1em;
  }

  .input-group input,
  .register-button {
    padding: 0.5em;
  }
}

.input-group {
  margin-bottom: 1.5em;
}

.input-group label {
  display: block;
  margin-bottom: 0.5em;
  color: #144c4c;
}

.input-group input,
.input-group textarea {
  width: 100%;
  padding: 0.75em;
  border: 1px solid #114040;
  border-radius: 4px;
  box-sizing: border-box;
}

.input-group input:focus,
.input-group textarea:focus {
  border-color: #144c4c;
  outline: none;
  box-shadow: 0 0 5px rgba(20, 64, 64, 0.5);
}

.register-button {
  width: 100%;
  padding: 1em;
  background-color: #144c4c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1em;
  transition: background-color 0.3s;
}

.register-button:hover {
  background-color: #114040;
}

.thankyou-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #dcca98;
  color: #144040;
  text-align: center;
}

.thankyou-container h2 {
  font-size: 36px;
  margin-bottom: 20px;
  color: #144040;
}

.thankyou-container p {
  font-size: 18px;
  margin-bottom: 20px;
  color: #144040;
}

.thankyou-home-button {
  padding: 10px 20px;
  background: #144040;
  color: #dcca98;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.tabs {
  margin-top: 20px;
}

.tab-list {
  display: flex;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  margin: 0;
  border-bottom: 2px solid #144040;
}

.tab-item {
  margin: 0 10px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1.4em;
  font-weight: bold;
  border: 1px solid transparent;
  border-bottom: none;
  color: #144c4c;
  transition: color 0.3s, background-color 0.3s;
}

.tab-item:hover,
.tab-item.active {
  color: #dcca98;
  background-color: #144c4c;
  border: 1px solid #dcca98;
  border-bottom: 2px solid #dcca98;
  background: linear-gradient(to right, #114040 0%, #144c4c 100%);
}

.tab-content {
  margin-top: 20px;
}

.tab-panel {
  display: none;
}

.tab-panel.active {
  display: block;
}

.assistant-details {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.assistant-details img {
  max-width: 300px;
  max-height: 300px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin: 0 auto;
}

.assistant-title-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.assistant-title-button:hover {
  background-color: #0056b3;
}

.clickable-image .hover-effect {
  transition: transform 0.3s ease;
}

.clickable-image .hover-effect:hover {
  transform: scale(1.05) translateY(-10px);
}

/* Media Queries for Mobile Devices */
@media (max-width: 768px) {
  .tab-list {
    flex-direction: column;
    align-items: center;
    border-bottom: none;
  }

  .tab-item {
    margin: 5px 0;
    padding: 10px;
    width: 100%;
    text-align: center;
    border: 1px solid #144c4c;
  }

  .tab-item.active {
    border: 1px solid #dcca98;
    border-bottom: none;
  }

  .assistant-details img {
    max-width: 100%;
    height: auto;
  }

  .assistant-title-button {
    width: 100%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .tab-item {
    font-size: 1em;
  }

  .assistant-title-button {
    font-size: 1em;
  }
}

/* Dropdown Wrapper and Toggle */
.dropdown-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 5px 0;
}

.dropdown-toggle {
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0;
  margin-left: 8px;
}

/* Fix navbar toggle button alignment */
.navbar-toggle {
  margin-top: 18px;
  margin-bottom: 18px;
  padding: 9px 10px;
}

/* Fix specific height for mobile */
@media (max-width: 767px) {
  #menu, #menu.navbar-default, .navbar-header {
    height: auto;
    min-height: 70px;
  }
  
  .navbar-toggle {
    display: block;
    margin-right: 15px;
  }
  
  .navbar-collapse {
    padding-top: 0;
    padding-bottom: 0;
  }
}

/* Dropdown Menu */
.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #144040;
  border: 1px solid #dcca98;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-menu li {
  width: 100%;
}

.dropdown-menu li a {
  color: #dcca98;
  padding: 15px 20px;
  text-decoration: none;
  display: block;
}

.dropdown-menu li a:hover {
  background-color: #dcca98;
  color:#114040;
}

@media (max-width: 767px) {
  .dropdown-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dropdown-menu {
    position: relative;
    top: 0;
    width: 100%;
  }
}


.enterprise-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
}

.enterprise-card {
  background-color: var(--secondary-color);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
}

.enterprise-title {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: var(--primary-color);
}

.enterprise-description {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: var(--primary-color);
}

.enterprise-button {
  background-color: var(--primary-color);
  color: #dcca98;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1.25rem;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.enterprise-button:hover {
  background-color: #0f3030;
}

/* Pricing Page */
.pricing-page {
  background-color: var(--primary-color);
  padding: 20px;
  padding-top: 100px;
  font-family: 'Arial, sans-serif';
  color: var(--secondary-color);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  gap: 16px;
}

.text-container {
  text-align: center;
}

.title {
  font-size: 2rem;
  font-weight: bold;
  color: var(--secondary-color);
  margin-bottom: 10px;
}

.subtitle {
  color: var(--secondary-color);
}

.stripe-pricing-table-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

/* Add responsive styles to ensure the table scales correctly */
@media (min-width: 768px) {
  .stripe-pricing-table-container {
    padding: 40px;
  }
}

/* Company Colors */
:root {
  --primary-color: #144040;
  --secondary-color: #DCCA98;
  --text-color: #333333;
}

/* Slideshow */
.slideshow {
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: auto;
  text-align: center;
  background-color: #dcca98;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.slideshowSlide {
  transition: opacity 0.5s ease-in-out;
}

.slide-image {
  max-width: 100px;
  height: auto;
  margin-bottom: 20px;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  color: #144040;
}

.arrow.left {
  left: 10px;
}

.arrow.right {
  right: 10px;
}

/* Pricing Page */
.pricing-page {
  background-color: #144040;
  padding: 20px;
  padding-top: 100px;
  font-family: 'Arial, sans-serif';
}

.container {
  max-width: 1200px;
  margin-bottom: 10;
  gap: 16px;
}

.text-container {
  text-align: center;
}

.stripe-pricing-table-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

/* Add responsive styles to ensure the table scales correctly */
@media (min-width: 768px) {
  .stripe-pricing-table-container {
    padding: 40px;
  }
}


.pricing-overlay {
  position: absolute;
  top: 800px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 600px);
  cursor: pointer;
  z-index: 10;
  background: transparent;
}


.account-setup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--primary-color);
}

.account-setup-form {
  background-color: var(--secondary-color);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.account-setup-form h2 {
  color: var(--primary-color);
  margin-bottom: 1rem;
  text-align: center;
}

.account-setup-form input,
.account-setup-form select,
.account-setup-form button {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: none;
  border-radius: 5px;
}

.account-setup-form input,
.account-setup-form select {
  background-color: #ffffff;
  color: var(--primary-color);
}

.account-setup-form button {
  background-color: var(--primary-color);
  color: var(--secondary-color);
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.account-setup-form button:hover {
  background-color: darken(var(--primary-color), 10%);
  color: var(--primary-color);
}

/* Add this CSS to your main stylesheet or create a new CSS file for the PaymentSuccess component */

.payment-success-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #333;
  text-align: center;
  padding: 20px;
}

.payment-success-container h2 {
  font-size: 2.5em;
  margin-bottom: 20px;
}

.payment-success-container p {
  font-size: 1.2em;
  margin-bottom: 20px;
}

.payment-success-container .button-container {
  margin-top: 30px;
}

.payment-success-container button {
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.payment-success-container button:hover {
  background-color: #144040;
  color: #dcca98;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background-color: #DCCA98;
  padding: 20px;
  border-radius: 5px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.modal-body {
  margin-bottom: 20px;
  color: #144040;
  font-size: 16px;
}

.modal-buttons-container {
  display: flex;
  justify-content: center;
}

.modal-button {
  background-color: #144040;
  color: #DCCA98;
  border: none;
  padding: 10px 20px;
  margin: 5px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.modal-button:hover {
  background-color: #113737;
}

.prompt-count-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #E8F0FE;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  font-size: 0.9em;
  color: #333;
  margin-top: 10px;
}

.prompt-count-text {
  margin: 0;
  font-weight: bold;
}

.upgrade-message {
  background-color: #FFD700;
  color: #222222;
  padding: 5px 10px;
  border-radius: 3px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.upgrade-message:hover {
  background-color: #FFC107;
}

.sidebar-open {
  margin-left: 250px;
}

/* Adjust the content area when the sidebar is closed */
.sidebar-closed {
  margin-left: 0;
}

.welcome-video-container {
  text-align: center;
  margin-top: 20px;
  padding: 10px;
}

.video-wrapper {
  position: relative;
  max-height: 100vh;
  margin: 0 auto;
}

.video-wrapper iframe {
  width: 700px;
  height: 400px;
}

/* Media query for tablets and smaller screens (768px and below) */
@media (max-width: 768px) {
  .video-wrapper iframe {
    width: 90%;
    height: calc(90% * 0.5625);
  }
}

/* Media query for small screens (mobile devices below 480px) */
@media (max-width: 480px) {
  .video-wrapper iframe {
    width: 100%;
    height: calc(100% * 0.5625);
  }
}

/* Media query for large screens (above 1200px) */
@media (min-width: 1200px) {
  .video-wrapper iframe {
    width: 800px;
    height: 450px;
  }
}

.dropdown-wrapper a {
  text-decoration: none;
  color: #000000;
  font-family: "Lato", sans-serif;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 400;
  padding: 12px 2px;
}

.dropdown-toggle .icon-bar {
  width: 22px;
  height: 2px;
  background-color: #333;
  margin: 4px 0;
}

/* Create a dedicated navbar container class */
.navbar-container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: auto;
  min-height: 70px;
}

/* Mobile navbar adjustments */
@media (max-width: 767px) {
  .navbar-container {
    padding: 0 15px;
    flex-wrap: wrap;
  }
  
  .navbar-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: auto;
    min-height: 70px;
    padding: 5px 0;
  }
  
  .navbar-collapse {
    width: 100%;
  }
}

/* Fix collapsed navbar in mobile view */
.navbar-default .navbar-collapse {
  border: none;
  box-shadow: none;
  background-color: #dcca98;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;;EAEE,oCAAoC;EACpC,6CAA6C;EAC7C,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,+DAA+D;EAC/D,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,0EAA0E;EAC1E,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+DAA+D;EAC/D,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,qEAAqE;EACrE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;;;;EAKE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;EAEV,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,aAAa;EACb,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,UAAU;EACV,iFAAsE;EACtE,yBAAyB;EAGzB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,+EAA+E;EAC/E,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,+EAA+E;EAC/E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+DAA+D;EAC/D,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+DAA+D;EAC/D,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,+DAA+D;EAC/D,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+DAA+D;EAC/D,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;EACf,+DAA+D;EAC/D,kBAAkB;EAClB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,+FAA+F;EAC/F,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,cAAc;EAEd,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mCAAmC;EAEnC,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;;AAGA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,gCAAgC;EAChC,+DAA+D;AACjE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,qCAAqC;AACrC;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;AACF;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE;IACE,aAAa;EACf;AACF;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA,mGAAmG;;AAEnG;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,kEAAkE;AAClE;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["/* General styles */\nbody,\nhtml {\n  font-family: \"Open Sans\", sans-serif;\n  text-rendering: optimizeLegibility !important;\n  -webkit-font-smoothing: antialiased !important;\n  color: #000000;\n  font-weight: 400;\n  width: 100% !important;\n  height: 100% !important;\n  background-color: #dcca98;\n}\nh2,\nh3,\n\nh4 {\n  font-family: \"Raleway\", sans-serif;\n}\n\nh2 {\n  text-transform: uppercase;\n  margin: 0 0 20px;\n  font-weight: 800;\n  font-size: 36px;\n  color: #114040;\n}\n\nh3 {\n  font-size: 30px;\n  font-weight: 600;\n  color: #114040;\n}\n\nh4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #114040;\n}\n\n.h4-text {\n  font-size: 18px;\n  color: #dcca98;\n  font-weight: 600;\n}\n\nh5 {\n  text-transform: uppercase;\n  font-weight: 700;\n  line-height: 20px;\n}\n\nh6 {\n  justify-content: center;\n  text-transform: uppercase;\n  margin: 0 0 20px;\n  font-size: large;\n  font-weight: bold;\n  color: #dcca98;\n}\n\np {\n  font-size: 16px;\n}\n\np.intro {\n  margin: 12px 0 0;\n  line-height: 24px;\n}\n\na {\n  color: #608dfd;\n  font-weight: 400;\n}\n\na:hover,\na:focus {\n  text-decoration: none;\n  color: #608dfd;\n}\n\nul,\nol {\n  list-style: none;\n  padding: 0;\n}\n\nhr {\n  height: 2px;\n  width: 70px;\n  text-align: center;\n  position: relative;\n  background: #000000;\n  margin-bottom: 20px;\n  border: 0;\n}\n\n/* Navigation */\n#menu {\n  padding: 0;\n  transition: all 0.8s;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 70px;\n  width: 100%;\n  margin: 0;\n}\n\n#menu.navbar-default {\n  background-color: #dcca98;\n  border-color: rgba(231, 231, 231, 0);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  overflow: visible;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  height: 70px;\n  margin: 0;\n  border: none;\n  padding: 0;\n}\n\n#menu a.navbar-brand {\n  font-family: \"Raleway\", sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #000000;\n  text-transform: uppercase;\n  padding: 0 15px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  overflow: visible;\n}\n\n#menu.navbar-default .navbar-nav {\n  display: flex;\n  height: 70px;\n  align-items: center;\n  margin: 0;\n}\n\n#menu.navbar-default .navbar-nav > li {\n  list-style: none;\n  margin: 0 15px;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n#menu.navbar-default .navbar-nav > li > a {\n  font-family: \"Lato\", sans-serif;\n  text-transform: uppercase;\n  color: #000000;\n  font-size: 16px;\n  font-weight: 400;\n  padding: 12px 2px;\n  border-radius: 0;\n  position: relative;\n}\n\n#menu.navbar-default .navbar-nav > li > a:after {\n  display: block;\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(to right, #114040 0%, #144c4c 100%);\n  content: \"\";\n  transition: width 0.2s;\n}\n\n#menu.navbar-default .navbar-nav > li > a:hover:after {\n  width: 100%;\n}\n\n.navbar-default .navbar-nav > .active > a,\n.navbar-default .navbar-nav > .active > a:hover,\n.navbar-default .navbar-nav > .active > a:focus {\n  background-color: transparent;\n}\n\n.navbar-default .navbar-nav > .active > a:after,\n.navbar-default .navbar-nav > .active > a:hover:after,\n.navbar-default .navbar-nav > .active > a:focus:after {\n  display: block !important;\n  position: absolute !important;\n  left: 0 !important;\n  bottom: -1px !important;\n  width: 100% !important;\n  height: 2px !important;\n  background: linear-gradient(to right, #114040 0%, #144c4c 100%) !important;\n  content: \"\" !important;\n  transition: width 0.2s !important;\n}\n\n@media (max-width: 767px) {\n  .navbar-nav {\n    display: block;\n    text-align: center;\n  }\n\n  .navbar-nav li {\n    display: block;\n    margin: 0;\n  }\n\n  .navbar-nav li a {\n    padding: 15px;\n  }\n}\n\n.brand-title,\n.brand-subtitle {\n  display: block;\n  line-height: 1;\n}\n\n.brand-subtitle {\n  font-size: 13px;\n  color: #144c4c;\n}\n\n.brand-container {\n  display: flex;\n  align-items: center;\n  height: 70px;\n  overflow: visible;\n}\n\n.brand-logo {\n  width: 45px;\n  height: 45px;\n  margin-right: 15px;\n  object-fit: contain;\n}\n\n/* Brand text container */\n.brand-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 45px;\n}\n\n.brand-title {\n  font-size: 18px;\n  line-height: 1.4;\n  font-weight: bold;\n  margin: 0;\n}\n\n.brand-subtitle {\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 0;\n}\n\n@media (min-width: 768px) {\n  .brand-title,\n  .brand-subtitle {\n    display: inline;\n  }\n}\n\n\n.section-title {\n  margin-bottom: 70px;\n}\n\n.section-title h2 {\n  position: relative;\n  margin-top: 10px;\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n}\n\n.section-title h2::after {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(to right, #114040 0%, #144c4c 100%);\n  height: 4px;\n  width: 60px;\n  bottom: 0;\n  margin-left: -30px;\n  left: 50%;\n}\n\n.section-title p {\n  font-size: 18px;\n}\n\n.btn-custom {\n  font-family: \"Raleway\", sans-serif;\n  text-transform: uppercase;\n  color: #dcca98;\n  background-color: #5ca9fb;\n  background-image: linear-gradient(to right, #114040 0%, #144c4c 100%);\n  padding: 14px 34px;\n  letter-spacing: 1px;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 25px;\n  transition: all 0.5s linear;\n  border: 0;\n}\n\n.btn-custom:hover,\n.btn-custom:focus,\n.btn-custom.focus,\n.btn-custom:active,\n.btn-custom.active {\n  color: #fff;\n  background-image: none;\n  background-color: #6372ff;\n}\n\n.btn:active,\n.btn.active {\n  background-image: none;\n  outline: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\na:focus,\n.btn:focus,\n.btn:active:focus,\n.btn.active:focus,\n.btn.focus,\n.btn:active.focus,\n.btn.active.focus {\n  outline: none;\n  outline-offset: none;\n}\n\n/* Header Section */\n.intro {\n  width: 100%;\n  padding: 0;\n  background: url(../src/img/intro-bg.jpg) center center no-repeat fixed;\n  background-color: #144040;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  background-size: cover;\n  -o-background-size: cover;\n  position: relative;\n}\n\n.intro .overlay {\n  background: rgba(0, 0, 0, 0.4);\n  padding: 100px 0;\n}\n\n.header-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  min-height: 550px;\n}\n\n.intro-text {\n  position: relative;\n  z-index: 2;\n}\n\n.intro h1 {\n  font-family: \"Times\", cursive;\n  color: #ffbb00;\n  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n  font-size: 40px;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin-top: 0;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.intro h1 span {\n  font-weight: 800;\n  color: #5ca9fb;\n}\n\n.intro p {\n  text-align: center;\n  font-family: \"Times\", cursive;\n  color: #ffbb10;\n  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 30px;\n  margin: 0 auto;\n  margin-bottom: 60px;\n}\n\nheader .intro-text {\n  padding-top: 50px;\n  padding-bottom: 50px;\n  min-height: 450px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Responsive adjustments for smaller screens */\n@media screen and (max-width: 767px) {\n  .intro {\n    height: auto;\n  }\n\n  .intro .overlay {\n    padding: 60px 0;\n  }\n\n  .header-row {\n    min-height: auto;\n  }\n\n  .intro h1 {\n    font-size: 24px;\n    text-align: center;\n  }\n\n  .intro p {\n    font-size: 16px;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n  .intro-text {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    min-height: auto;\n  }\n}\n\n/* meetyourassistants Section */\n#meetyourassistants {\n  padding: 100px 0;\n  background: #114040;\n}\n\n#meetyourassistants h2 {\n  color: #dcca98;\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n}\n\n#meetyourassistants h3 {\n  color: #dcca98;\n}\n\n#meetyourassistants p {\n  color: #dcca98;\n}\n\n#meetyourassistants i.fa {\n  font-size: 38px;\n  margin-bottom: 20px;\n  transition: all 0.5s;\n  color: #dcca98;\n  width: 100px;\n  height: 100px;\n  padding: 30px 0;\n  border-radius: 50%;\n  background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);\n  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.05);\n}\n\n#meetyourassistants .section-title h2::after {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);\n  height: 4px;\n  width: 60px;\n  bottom: 0;\n  margin-left: -30px;\n  left: 50%;\n}\n\n/* About Section */\n#about {\n  padding-top: 100px;\n  background: #dcca98;\n  padding-bottom: -100px;\n}\n\n#about h3 {\n  font-size: 22px;\n  margin: 0 0 20px;\n}\n\n#about h2 {\n  position: relative;\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n}\n\n#about .section-title h2::after {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(to right, #144c4c 0%, #144040 100%);\n  height: 4px;\n  width: 60px;\n  bottom: 0;\n  margin-left: -30px;\n  left: 50%;\n}\n\n#about .about-text li {\n  margin-bottom: 6px;\n  margin-left: 6px;\n  list-style: none;\n  padding: 0;\n  font-size: 16px;\n}\n\n#about .about-text li:before {\n  content: \"\\f00c\";\n  font-family: \"FontAwesome\";\n  color: #114040;\n  font-size: 16px;\n  font-weight: 300;\n  padding-right: 8px;\n}\n\n#about img {\n  width: 520px;\n  margin-top: 30px;\n  background: #dcca98;\n  border-right: 0;\n  box-shadow: 0 0 50px rgba(0, 0, 0, 0.06);\n}\n\n#about p {\n  line-height: 24px;\n  margin: 30px 0;\n}\n\n/* features Section */\n#features {\n  padding: 100px 0;\n  background: linear-gradient(to right, #114040 0%, #144c4c 100%);\n  color: #dcca98;\n}\n\n#features .features-desc {\n  margin: 10px 10px 20px;\n}\n\n#features h2 {\n  color: #dcca98;\n}\n\n#features .section-title h2::after {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);\n  height: 4px;\n  width: 60px;\n  bottom: 0;\n  margin-left: -30px;\n  left: 50%;\n}\n\n#features i.fa {\n  font-size: 42px;\n  width: 120px;\n  height: 120px;\n  padding: 40px 0;\n  background: linear-gradient(to right, #114040 0%, #144c4c 100%);\n  border-radius: 50%;\n  color: #dcca98;\n  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.05);\n}\n\n#features h3 {\n  font-weight: 500;\n  padding: 5px 0;\n  color: #dcca98;\n}\n\n#features p {\n  color: #dcca98;\n}\n\n#features .features-desc {\n  margin-bottom: 40px;\n}\n\n/* Assistants Section */\n#assistants {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-top: 100px;\n  padding-bottom: 100px;\n  background-color: #dcca98;\n  width: 100%;\n  min-height: 100vh;\n  box-sizing: border-box;\n  position: relative;\n}\n\n/* For devices with max width of 500px and specific viewport heights */\n@media (max-width: 500px) and (max-height: 700px) {\n  #assistants {\n    margin-bottom: 120px;\n    min-height: 150vh;\n  }\n}\n\n@media (max-width: 500px) and (max-height: 800px) {\n  #assistants {\n    padding-bottom: 180px;\n    min-height: 100vh;\n  }\n}\n\n@media (max-width: 500px) and (max-height: 900px) {\n  #assistants {\n    padding-bottom: 180px;\n    min-height: 100vh;\n  }\n}\n\n@media (max-width: 500px) and (max-height: 1000px) {\n  #assistants {\n    margin-bottom: 120px;\n    min-height: 150vh;\n  }\n}\n\n/* Ensure the container takes up the appropriate width */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  height: auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n/* Assistants Item */\n.assistants-item {\n  width: 100%;\n  max-width: 300px;\n  margin: 0 auto;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Tab content to arrange the assistants */\n.tab-content {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  flex-grow: 1;\n}\n\n.assistants-item img {\n  width: 100%;\n  height: auto;\n}\n\n.assistants-item .hover-bg {\n  overflow: hidden;\n  position: relative;\n  margin: 0;\n}\n\n.hover-bg .hover-text {\n  position: absolute;\n  text-align: center;\n  margin: 0 auto;\n  color: #dcca98;\n  background: linear-gradient(to right, rgba(99, 114, 255, 0.8) 0%, rgba(92, 169, 251, 0.8) 100%);\n  padding: 30% 0 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  transition: all 0.5s;\n}\n\n.hover-bg .hover-text > h4 {\n  opacity: 0;\n  color: #000000;\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%);\n  transition: all 0.3s;\n  font-size: 18px;\n  letter-spacing: 1px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.hover-bg:hover .hover-text > h4 {\n  opacity: 1;\n  -webkit-backface-visibility: hidden;\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n}\n\n.hover-bg:hover .hover-text {\n  opacity: 1;\n}\n\n/* Team Section */\n#team {\n  padding: 100px 0;\n  background: #dcca98;\n}\n\n#team h4 {\n  margin: 5px 0;\n}\n\n#team .team-img {\n  width: 240px;\n}\n\n#team .thumbnail {\n  background: transparent;\n  border: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 100%;\n  height: auto;\n  margin-bottom: 15px;\n}\n\n#team .thumbnail .caption {\n  padding: 10px 0 0;\n  color: #000000;\n  text-align: center;\n}\n\n\n/* Footer Section */\n#footer {\n  background: #dcca98;\n  padding: 30px 0;\n}\n\n#footer p {\n  color: #114040;\n  font-size: 16px;\n}\n\n#footer a {\n  color: #114040;\n}\n\n#footer a:hover {\n  border-bottom: 2px solid #114040;\n}\n\n/* Navigation.css */\n.navbar-header {\n  display: flex;\n  align-items: center;\n  height: 70px;\n  overflow: visible;\n  padding: 0;\n}\n\n.brand-container {\n  display: flex;\n  align-items: center;\n  height: 70px;\n  overflow: visible;\n}\n\n.brand-logo {\n  width: 45px;\n  height: 45px;\n  margin-right: 15px;\n  object-fit: contain;\n}\n\n/* Brand text container */\n.brand-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 45px;\n}\n\n.brand-title {\n  font-size: 18px;\n  line-height: 1.4;\n  font-weight: bold;\n  margin: 0;\n}\n\n.brand-subtitle {\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 0;\n}\n\n.assistants-section .assistant-title h4 {\n  margin: 0 auto;\n  text-align: center;\n  padding-bottom: 10px;\n  color: #dcca98;\n}\n\n.assistants-section .assistant-title-button {\n  background-color: #144c4c;\n  border: none;\n  font-size: large;\n  font-weight: bold;\n  color: #dcca98;\n  padding: 10px 20px;\n  text-align: center;\n  width: 100%;\n  display: block;\n  cursor: pointer;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  border-radius: 5px;\n}\n\n.assistants-section .assistant-title-button:hover {\n  background-color: #114040;\n  transform: scale(1.05);\n}\n\n.assistants-section .assistant-container {\n  margin-top: 10px;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.assistants-section .hover-bg {\n  position: relative;\n  transition: transform 0.3s ease;\n}\n\n.assistants-section .hover-bg:hover {\n  transform: scale(1.05);\n}\n\n.assistants-section .hover-bg img {\n  width: 100%;\n  display: block;\n  transition: transform 0.3s ease;\n}\n\n.assistant-container img {\n  padding: 10px;\n  width: 100%;\n  max-width: 300px;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n  object-fit: cover;\n}\n\n.assistants-section .hover-text {\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  text-align: center;\n  color: white;\n  font-size: 20px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  background: rgba(49, 159, 218, 0.7);\n  padding: 10px 0;\n}\n\n.assistants-section .hover-bg:hover .hover-text {\n  opacity: 1;\n}\n\n@media (max-width: 768px) {\n  #about img {\n    margin: 50px 0;\n  }\n}\n\n/* Modal.css */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.modal-content {\n  padding: 2em;\n  background: #dcca98;\n  border-radius: 5px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  max-width: 600px;\n  width: 50%;\n  margin: auto;\n  text-align: center;\n}\n\n.modal-message {\n  text-align: center;\n  margin-bottom: 1em;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #144c4c;\n}\n\n.modal-submessage-container {\n  max-height: 100px;\n  overflow-y: auto;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #DCF8C6;\n  width: calc(100% - 20px);\n  max-height: 7em;\n  margin: -10px 10px 0px 10px;\n  font-size: small;\n}\n\n.modal-textarea {\n  width: calc(100% - 20px);\n  padding: 10px;\n  margin: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  resize: none;\n  height: 6em;\n}\n\n@media (min-width: 600px) {\n  .modal-content {\n    width: 70%;\n  }\n}\n\n@media (max-width: 600px) {\n  .modal-content {\n    width: 90%;\n    padding: 1em;\n  }\n\n  .modal-message {\n    font-size: 1rem;\n  }\n\n  .modal-submessage {\n    font-size: 0.8rem;\n  }\n\n  .modal-button.login {\n    font-size: 1rem;\n  }\n\n  .modal-button.cancel {\n    font-size: 1rem;\n  }\n}\n\n/* Modal.css */\n.modal-buttons-container {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  width: 100%;\n}\n\n.modal-button {\n  padding: 10px 20px;\n  font-size: 1.5rem;\n  color: #fff;\n  background-color: #114040;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  outline: none;\n}\n\n.modal-button.login {\n  background-color: #114040;\n}\n\n.modal-button.cancel {\n  background-color: #357d7c;\n}\n\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.popup-content {\n  background: #dcca98;\n  padding: 20px;\n  border-radius: 5px;\n  text-align: center;\n  z-index: 10000;\n  color: #144040;\n}\n\n.popup-content h2 {\n  margin-bottom: 20px;\n  color: #144040;\n}\n\n.popup-content p {\n  margin-bottom: 20px;\n  color: #144040;\n}\n\n.popup-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n}\n\n.popup-content button {\n  padding: 10px 20px;\n  background: #144040;\n  color: #dcca98;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.popup-content button:hover {\n  background: #0F3030;\n}\n\n.register-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #114040;\n}\n\n.home-button {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  padding: 10px 20px;\n  background-color: #dcca98;\n  color: #144c4c;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  transition: background-color 0.3s;\n}\n\n.home-button:hover {\n  background-color: #bbaa88;\n}\n\n.register-form {\n  padding: 2em;\n  background: #dcca98;\n  border-radius: 5px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  max-width: 600px;\n  width: 50%;\n  margin: auto;\n}\n\n.register-form h2 {\n  text-align: center;\n  margin-bottom: 1em;\n  color: #144c4c;\n}\n\n.register-form .event-description {\n  font-size: 1em;\n  color: #144c4c;\n  margin-bottom: 1.5em;\n  line-height: 1.5;\n}\n\n@media (max-width: 1024px) {\n  .register-form {\n    width: 70%;\n  }\n}\n\n@media (max-width: 600px) {\n  .register-form {\n    width: 90%;\n    padding: 1em;\n  }\n\n  .input-group input,\n  .register-button {\n    padding: 0.5em;\n  }\n}\n\n.input-group {\n  margin-bottom: 1.5em;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 0.5em;\n  color: #144c4c;\n}\n\n.input-group input,\n.input-group textarea {\n  width: 100%;\n  padding: 0.75em;\n  border: 1px solid #114040;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.input-group input:focus,\n.input-group textarea:focus {\n  border-color: #144c4c;\n  outline: none;\n  box-shadow: 0 0 5px rgba(20, 64, 64, 0.5);\n}\n\n.register-button {\n  width: 100%;\n  padding: 1em;\n  background-color: #144c4c;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1em;\n  transition: background-color 0.3s;\n}\n\n.register-button:hover {\n  background-color: #114040;\n}\n\n.thankyou-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #dcca98;\n  color: #144040;\n  text-align: center;\n}\n\n.thankyou-container h2 {\n  font-size: 36px;\n  margin-bottom: 20px;\n  color: #144040;\n}\n\n.thankyou-container p {\n  font-size: 18px;\n  margin-bottom: 20px;\n  color: #144040;\n}\n\n.thankyou-home-button {\n  padding: 10px 20px;\n  background: #144040;\n  color: #dcca98;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.tabs {\n  margin-top: 20px;\n}\n\n.tab-list {\n  display: flex;\n  justify-content: center;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  border-bottom: 2px solid #144040;\n}\n\n.tab-item {\n  margin: 0 10px;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-size: 1.4em;\n  font-weight: bold;\n  border: 1px solid transparent;\n  border-bottom: none;\n  color: #144c4c;\n  transition: color 0.3s, background-color 0.3s;\n}\n\n.tab-item:hover,\n.tab-item.active {\n  color: #dcca98;\n  background-color: #144c4c;\n  border: 1px solid #dcca98;\n  border-bottom: 2px solid #dcca98;\n  background: linear-gradient(to right, #114040 0%, #144c4c 100%);\n}\n\n.tab-content {\n  margin-top: 20px;\n}\n\n.tab-panel {\n  display: none;\n}\n\n.tab-panel.active {\n  display: block;\n}\n\n.assistant-details {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.assistant-details img {\n  max-width: 300px;\n  max-height: 300px;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  margin: 0 auto;\n}\n\n.assistant-title-button {\n  margin-top: 10px;\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.assistant-title-button:hover {\n  background-color: #0056b3;\n}\n\n.clickable-image .hover-effect {\n  transition: transform 0.3s ease;\n}\n\n.clickable-image .hover-effect:hover {\n  transform: scale(1.05) translateY(-10px);\n}\n\n/* Media Queries for Mobile Devices */\n@media (max-width: 768px) {\n  .tab-list {\n    flex-direction: column;\n    align-items: center;\n    border-bottom: none;\n  }\n\n  .tab-item {\n    margin: 5px 0;\n    padding: 10px;\n    width: 100%;\n    text-align: center;\n    border: 1px solid #144c4c;\n  }\n\n  .tab-item.active {\n    border: 1px solid #dcca98;\n    border-bottom: none;\n  }\n\n  .assistant-details img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .assistant-title-button {\n    width: 100%;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tab-item {\n    font-size: 1em;\n  }\n\n  .assistant-title-button {\n    font-size: 1em;\n  }\n}\n\n/* Dropdown Wrapper and Toggle */\n.dropdown-wrapper {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 5px 0;\n}\n\n.dropdown-toggle {\n  border: none;\n  background: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 0;\n  margin-left: 8px;\n}\n\n/* Fix navbar toggle button alignment */\n.navbar-toggle {\n  margin-top: 18px;\n  margin-bottom: 18px;\n  padding: 9px 10px;\n}\n\n/* Fix specific height for mobile */\n@media (max-width: 767px) {\n  #menu, #menu.navbar-default, .navbar-header {\n    height: auto;\n    min-height: 70px;\n  }\n  \n  .navbar-toggle {\n    display: block;\n    margin-right: 15px;\n  }\n  \n  .navbar-collapse {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n}\n\n/* Dropdown Menu */\n.dropdown-menu {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: #144040;\n  border: 1px solid #dcca98;\n  border-radius: 10px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-menu li {\n  width: 100%;\n}\n\n.dropdown-menu li a {\n  color: #dcca98;\n  padding: 15px 20px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown-menu li a:hover {\n  background-color: #dcca98;\n  color:#114040;\n}\n\n@media (max-width: 767px) {\n  .dropdown-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .dropdown-menu {\n    position: relative;\n    top: 0;\n    width: 100%;\n  }\n}\n\n\n.enterprise-card-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 2rem;\n}\n\n.enterprise-card {\n  background-color: var(--secondary-color);\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-width: 800px;\n  width: 100%;\n  text-align: center;\n  margin: 0 auto;\n}\n\n.enterprise-title {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  color: var(--primary-color);\n}\n\n.enterprise-description {\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  color: var(--primary-color);\n}\n\n.enterprise-button {\n  background-color: var(--primary-color);\n  color: #dcca98;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1.25rem;\n  font-weight: bold;\n  transition: background-color 0.3s ease;\n}\n\n.enterprise-button:hover {\n  background-color: #0f3030;\n}\n\n/* Pricing Page */\n.pricing-page {\n  background-color: var(--primary-color);\n  padding: 20px;\n  padding-top: 100px;\n  font-family: 'Arial, sans-serif';\n  color: var(--secondary-color);\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  gap: 16px;\n}\n\n.text-container {\n  text-align: center;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: bold;\n  color: var(--secondary-color);\n  margin-bottom: 10px;\n}\n\n.subtitle {\n  color: var(--secondary-color);\n}\n\n.stripe-pricing-table-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Add responsive styles to ensure the table scales correctly */\n@media (min-width: 768px) {\n  .stripe-pricing-table-container {\n    padding: 40px;\n  }\n}\n\n/* Company Colors */\n:root {\n  --primary-color: #144040;\n  --secondary-color: #DCCA98;\n  --text-color: #333333;\n}\n\n/* Slideshow */\n.slideshow {\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  max-width: 600px;\n  margin: auto;\n  text-align: center;\n  background-color: #dcca98;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.slideshowSlide {\n  transition: opacity 0.5s ease-in-out;\n}\n\n.slide-image {\n  max-width: 100px;\n  height: auto;\n  margin-bottom: 20px;\n}\n\n.arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  user-select: none;\n  color: #144040;\n}\n\n.arrow.left {\n  left: 10px;\n}\n\n.arrow.right {\n  right: 10px;\n}\n\n/* Pricing Page */\n.pricing-page {\n  background-color: #144040;\n  padding: 20px;\n  padding-top: 100px;\n  font-family: 'Arial, sans-serif';\n}\n\n.container {\n  max-width: 1200px;\n  margin-bottom: 10;\n  gap: 16px;\n}\n\n.text-container {\n  text-align: center;\n}\n\n.stripe-pricing-table-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Add responsive styles to ensure the table scales correctly */\n@media (min-width: 768px) {\n  .stripe-pricing-table-container {\n    padding: 40px;\n  }\n}\n\n\n.pricing-overlay {\n  position: absolute;\n  top: 800px;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 600px);\n  cursor: pointer;\n  z-index: 10;\n  background: transparent;\n}\n\n\n.account-setup-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: var(--primary-color);\n}\n\n.account-setup-form {\n  background-color: var(--secondary-color);\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-width: 400px;\n  width: 100%;\n}\n\n.account-setup-form h2 {\n  color: var(--primary-color);\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.account-setup-form input,\n.account-setup-form select,\n.account-setup-form button {\n  width: 100%;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  border: none;\n  border-radius: 5px;\n}\n\n.account-setup-form input,\n.account-setup-form select {\n  background-color: #ffffff;\n  color: var(--primary-color);\n}\n\n.account-setup-form button {\n  background-color: var(--primary-color);\n  color: var(--secondary-color);\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: bold;\n  transition: background-color 0.3s ease;\n}\n\n.account-setup-form button:hover {\n  background-color: darken(var(--primary-color), 10%);\n  color: var(--primary-color);\n}\n\n/* Add this CSS to your main stylesheet or create a new CSS file for the PaymentSuccess component */\n\n.payment-success-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  color: #333;\n  text-align: center;\n  padding: 20px;\n}\n\n.payment-success-container h2 {\n  font-size: 2.5em;\n  margin-bottom: 20px;\n}\n\n.payment-success-container p {\n  font-size: 1.2em;\n  margin-bottom: 20px;\n}\n\n.payment-success-container .button-container {\n  margin-top: 30px;\n}\n\n.payment-success-container button {\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.payment-success-container button:hover {\n  background-color: #144040;\n  color: #dcca98;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1050;\n}\n\n.modal-content {\n  background-color: #DCCA98;\n  padding: 20px;\n  border-radius: 5px;\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.modal-body {\n  margin-bottom: 20px;\n  color: #144040;\n  font-size: 16px;\n}\n\n.modal-buttons-container {\n  display: flex;\n  justify-content: center;\n}\n\n.modal-button {\n  background-color: #144040;\n  color: #DCCA98;\n  border: none;\n  padding: 10px 20px;\n  margin: 5px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 16px;\n  transition: background-color 0.3s ease;\n}\n\n.modal-button:hover {\n  background-color: #113737;\n}\n\n.prompt-count-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #E8F0FE;\n  padding: 10px;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  font-size: 0.9em;\n  color: #333;\n  margin-top: 10px;\n}\n\n.prompt-count-text {\n  margin: 0;\n  font-weight: bold;\n}\n\n.upgrade-message {\n  background-color: #FFD700;\n  color: #222222;\n  padding: 5px 10px;\n  border-radius: 3px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.upgrade-message:hover {\n  background-color: #FFC107;\n}\n\n.sidebar-open {\n  margin-left: 250px;\n}\n\n/* Adjust the content area when the sidebar is closed */\n.sidebar-closed {\n  margin-left: 0;\n}\n\n.welcome-video-container {\n  text-align: center;\n  margin-top: 20px;\n  padding: 10px;\n}\n\n.video-wrapper {\n  position: relative;\n  max-height: 100vh;\n  margin: 0 auto;\n}\n\n.video-wrapper iframe {\n  width: 700px;\n  height: 400px;\n}\n\n/* Media query for tablets and smaller screens (768px and below) */\n@media (max-width: 768px) {\n  .video-wrapper iframe {\n    width: 90%;\n    height: calc(90% * 0.5625);\n  }\n}\n\n/* Media query for small screens (mobile devices below 480px) */\n@media (max-width: 480px) {\n  .video-wrapper iframe {\n    width: 100%;\n    height: calc(100% * 0.5625);\n  }\n}\n\n/* Media query for large screens (above 1200px) */\n@media (min-width: 1200px) {\n  .video-wrapper iframe {\n    width: 800px;\n    height: 450px;\n  }\n}\n\n.dropdown-wrapper a {\n  text-decoration: none;\n  color: #000000;\n  font-family: \"Lato\", sans-serif;\n  text-transform: uppercase;\n  font-size: 16px;\n  font-weight: 400;\n  padding: 12px 2px;\n}\n\n.dropdown-toggle .icon-bar {\n  width: 22px;\n  height: 2px;\n  background-color: #333;\n  margin: 4px 0;\n}\n\n/* Create a dedicated navbar container class */\n.navbar-container {\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: auto;\n  min-height: 70px;\n}\n\n/* Mobile navbar adjustments */\n@media (max-width: 767px) {\n  .navbar-container {\n    padding: 0 15px;\n    flex-wrap: wrap;\n  }\n  \n  .navbar-header {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: auto;\n    min-height: 70px;\n    padding: 5px 0;\n  }\n  \n  .navbar-collapse {\n    width: 100%;\n  }\n}\n\n/* Fix collapsed navbar in mobile view */\n.navbar-default .navbar-collapse {\n  border: none;\n  box-shadow: none;\n  background-color: #dcca98;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
